module.exports = __webpack_public_path__ + "static/media/whyolive10.c5366189.jpg";